import React from "react";
import { useQuery } from "react-query";
import { upperCase, sortBy } from "lodash-es";
import { fetchReturnsConfiguration } from "../../api/fulfillment/returns";
import Table from "../../pages/_common/organization/OrganizationDetailsPage/Table";
import { useFacilityIndex } from "../../hooks/api/common/useFacilityIndex";
import { COLUMNS, returnConfigLabel } from "./helpers";

interface ReturnPreferenceTableProps {
  organizationId: string;
  preferredReturnFacility?: string;
}

export const ReturnPreferenceTable: React.FC<ReturnPreferenceTableProps> = ({
  organizationId,
  preferredReturnFacility,
}) => {
  const returnFacility = useFacilityIndex().data?.find((facility) => facility.name === preferredReturnFacility);
  const returnConfigs = useQuery(
    ["returnConfigs", organizationId],
    () => fetchReturnsConfiguration({ organization_id: organizationId }),
    {
      select: (configs) => {
        const unsortedReturnPreferences = [
          ...configs,
          {
            condition: "preferred_return_facility",
            instruction: upperCase(returnFacility?.name),
            address: returnFacility?.address,
          },
        ].map((config) => ({
          ...config,
          condition: returnConfigLabel[config.condition].title,
          position: returnConfigLabel[config.condition].position,
        }));
        return sortBy(unsortedReturnPreferences, "position");
      },
    }
  );

  return (
    <Table
      tableProps={{
        columns: COLUMNS,
        dataSource: returnConfigs.data ?? [],
        loading: returnConfigs.isLoading,
      }}
      title="Return Preferences"
    />
  );
};
